<div class="modal-content">
    <h3>{{ 'modal.report.title' | translate }}</h3>
    <p class="description">{{ 'modal.report.description' | translate }}</p>

    <form [formGroup]="reportForm" (ngSubmit)="sendReport()">
        <input formControlName="subject" type="text" name="subject" id="subject">
        <label for="bug-report">{{ 'modal.report.describe_problem' | translate }}</label>
        <textarea formControlName="issue" name="bug-report" id="bug-report" rows="15"></textarea>
        <!-- <div class="file-input-wrapper">
            <input type="file" id="file-input" multiple (change)="onFileSelected($event)">
            <label for="file-input" class="file-input-button">
                {{ 'common.choose_files' | translate }}
            </label>
        </div>

        <div class="selected-files" *ngIf="selectedFiles.length > 0">
            <h4>{{ 'modal.report.selected_files' | translate }} ({{selectedFiles.length}})</h4>
            <div class="file-list">
                <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
                    <span class="file-name">{{ file.name }}</span>
                    <span class="file-size">({{ (file.size / 1024 / 1024).toFixed(2) }} MB)</span>
                    <button type="button" class="remove-file" (click)="removeFile(i)" title="Supprimer">×</button>
                </div>
            </div>
        </div> -->
        <footer>
            <app-button [disabled]="reportForm.invalid" type="submit">{{'common.send' | translate}}</app-button>
            <app-button type="danger" (onClick)="cancel.emit()">{{'common.cancel' | translate}}</app-button>
        </footer>
    </form>
</div>